import { DeheadingPeelingRequestDto, AllDeheadingpeelingResponse, CommonResponse, DeheadingRatesRequest, DeheadingRatesRequestDto } from "@gtpl/shared-models/masters";
import axios from "axios";
import connection from "./connection";

export class DeheadingRatesService{
    URL = connection.DEPLOY_URL + '/deheading-rates';

    
    

    async saveDeheadingRatesInfo(req:DeheadingRatesRequestDto): Promise<CommonResponse> {
        return await axios.post(this.URL + '/saveDeheadingRatesInfo',req)
            .then(res => {
                return res.data
            })
    }
    async getAllDegeadingRatesData():Promise<CommonResponse>{
        return await axios.post(this.URL + '/getAllDegeadingRatesData')
        .then(res=>{
            return res.data
        })
    }
}